import BaseApi from './BaseApi'

export default class RolesApi extends BaseApi {
    async getRoles () {
        return this.get('/api/v1.0/roles')
    }
}
